import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupUserList } from '@shared/api/types';
import { useGroupUsersColumns } from './group-users-table-columns';

interface GroupUsersTableProps extends DataTableProps<PaginatedGroupUserList> {
  pageCount: number;
}

export default function GroupUsersTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
}: GroupUsersTableProps) {
  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupUsersColumns(),
    pageCount,
    getRowId: (row) => row.email,
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
